import { GoalFilterDocument, GoalType, ID } from '@griply/types';
import { getWeekStartsOn, processGoalsByFilterDocument } from '@griply/utils';
import { useSortedGoals } from 'features/goals';
import { useMemo } from 'react';
import { useTaskCounts } from 'shared/contexts/task-counts/use-task-counts';
import { useToday } from 'shared/contexts/today';
import { useEntityLinks } from 'shared/hooks/use-entity-links';
import { useUser } from 'shared/hooks/use-user';

export type Options = {
  customOrder?: ID[];
  goalTypeFilter?: GoalType[];
};

export const useGoalsByFilterDocument = (
  filterDocument: GoalFilterDocument | undefined,
  { customOrder, goalTypeFilter }: Options,
) => {
  const sortedGoals = useSortedGoals();
  const user = useUser();
  const today = useToday();
  const taskCounts = useTaskCounts();
  const links = useEntityLinks();
  const weekStartsOn = getWeekStartsOn(user);

  return useMemo(
    () =>
      processGoalsByFilterDocument(sortedGoals, filterDocument, {
        links,
        customOrder,
        today,
        weekStartsOn,
        taskCounts: taskCounts?.byGoalId,
        goalProgressCounts: taskCounts?.byGoalProgress,
        goalTypeFilter,
      }),
    [
      customOrder,
      filterDocument,
      goalTypeFilter,
      links,
      sortedGoals,
      today,
      weekStartsOn,
      taskCounts?.byGoalId,
      taskCounts?.byGoalProgress,
    ],
  );
};
